import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 20px 0;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.5em;
                }
            }

            p {
                font-size: 1.2em;
                line-height: 1.6;
                opacity: 0.9;
                margin: 0;
            }
        }
    `,
    ContentWrapper: styled.div`
        max-width: 1400px;
        margin: -40px auto 0;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        gap: 40px;
        position: relative;
        z-index: 10;

        /* GENERAL CARD STYLING */
        .data-card {
            background: #ffffff;
            border-radius: 20px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
            overflow: hidden;
            border: 1px solid rgba(0,0,0,0.05);

            .card-header {
                padding: 24px 30px;
                border-bottom: 1px solid #f1f5f9;
                display: flex;
                align-items: center;
                justify-content: space-between;

                h2 {
                    margin: 0;
                    font-size: 1.4em;
                    font-weight: 700;
                    color: #1e293b;
                }

                .badge {
                    background: #e0f2fe;
                    color: #0369a1;
                    padding: 6px 12px;
                    border-radius: 20px;
                    font-size: 0.9em;
                    font-weight: 600;
                }
            }
        }

        /* MAP CARD SPECIFIC */
        .map-card {
            .card-header {
                .legend {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    
                    .legend-color {
                        width: 16px;
                        height: 16px;
                        background: #01aecb;
                        border-radius: 4px;
                    }

                    span {
                        font-size: 0.95em;
                        color: #64748b;
                        font-weight: 500;
                    }
                }
            }

            .map-container {
                position: relative;
                padding: 30px;
                background: #f8fafc;

                /* SVG Styles */
                .svg-turkiye-haritasi {
                    max-width: 1000px;
                    height: 50vh;
                    margin: 0 auto;
                    
                    @media (max-width: 768px) {
                        height: auto;
                    }

                    svg {
                        width: 100%;
                        height: 100%;
                    }
                }

                #svg-turkiye-haritasi path {
                    cursor: pointer;
                    fill: #cbd5e1;
                    transition: fill 0.3s ease;
                }
                
                #svg-turkiye-haritasi path:hover {
                    fill: #01aecb;
                }

                .il-isimleri {
                    position: absolute;
                    z-index: 10;
                    pointer-events: none;
                }
                
                .il-isimleri div {
                    font-family: 'Inter', sans-serif;
                    background: #1e293b;
                    color: #fff;
                    padding: 6px 12px;
                    border-radius: 6px;
                    font-size: 0.9em;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                }
            }
        }

        /* TABLES WRAPPER */
        .tables-grid {
            display: flex;
            flex-direction: column;
            gap: 50px;
            width: 100%;
        }

        /* SCHOLARSHIP CONTAINER (ScholarshipTable.js wrapper) */
        .scholarship-container {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
            gap: 30px;
            align-items: start;

            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }
        }

        /* TABLE RESPONSIVE & STYLING */
        .table-responsive {
            max-height: 500px;
            overflow-y: auto;
            
            /* Custom Scrollbar */
            &::-webkit-scrollbar {
                width: 8px;
            }
            &::-webkit-scrollbar-track {
                background: #f1f5f9;
            }
            &::-webkit-scrollbar-thumb {
                background: #cbd5e1;
                border-radius: 4px;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: #94a3b8;
            }
        }

        .modern-table {
            width: 100%;
            border-collapse: collapse;
            text-align: left;

            th {
                position: sticky;
                top: 0;
                background: #f8fafc;
                padding: 14px 20px;
                color: #475569;
                font-weight: 600;
                font-size: 0.85em;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                border-bottom: 2px solid #e2e8f0;
                z-index: 2;
                box-shadow: 0 2px 4px rgba(0,0,0,0.02);
            }

            td {
                padding: 14px 20px;
                border-bottom: 1px solid #f1f5f9;
                color: #334155;
                font-size: 0.9em;
                line-height: 1.4;
            }

            tbody tr {
                transition: background 0.2s ease;

                &:hover {
                    background: #f0fdf4;
                    
                    td {
                        color: #0f172a;
                    }
                }
            }
        }
    `
};

export default S;